import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FiMessageSquare } from 'react-icons/fi';
import { Box, Typography } from '@mui/material';

const EmptyContent = ({ ...rest }) => {
  const { t } = useTranslation();

  return (
    <Box
      {...rest}
      padding={4}
      display="flex"
      color="#BDBDBD"
      alignItems="center"
      flexDirection="column"
      justifyContent="center">
      <Box component={FiMessageSquare} fontSize={40} marginBottom={4} />
      <Typography>{t('there is no data to show')}</Typography>
    </Box>
  );
};

export default memo(EmptyContent);
